/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import { navbarHeight, footerHeight } from '../../../../helpers/variableDefaults'
import { advisoryTypography } from '../../../../helpers/typographies'
import { standardButton } from '../../../../helpers/buttons'

export const submitSuccessfulJSX = (selectedReviewType, handleBackToDashboard) => {

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
    >
      {/* Text */}
      <Typography
        textAlign={'center'}
        sx={{
          width: '100%',
          // maxWidth: '400px',
          fontWeight: 'bold',
          fontSize: '18px',

        }}
      >
        Congrats! Your profile review request was submitted successfully!
      </Typography>

      <Box
        sx={{
          width: '100%',
          maxWidth: '900px',
          fontWeight: 'bold',
          fontSize: '18px',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {advisoryTypography(
          `You will receive an email with a link to the review when the review is completed
          ${selectedReviewType.type === 'AI' ? `AI Reviews are usually completed within 5 minutes` : selectedReviewType.type === 'Friend' ? `Your friend will complete the review by clicking on the link and inputting the security code found in the email that was sent to them by Swipelytics. If they did not receive an email, make sure they check their spam folder.` : `Expert Reviews are usually completed within 24 hours`}`
        )}
      </Box>

      {/* Button — Back to Dashboard */}
      {standardButton(
        'Back to Dashboard', 
        'button',
        'contained',
        false,
        'primary', 
        1,
        2,
        0,
        '220px', 
        '45px', 
        handleBackToDashboard
      )}

    </Box>
  )
}